import { __rest, __assign } from '../node_modules/tslib/tslib.es6.esm.js';
import React__default, { Children } from 'react';
import { NvTabsContainer } from './NvTabsContainer/NvTabsContainer.esm.js';
import { NvTabsContent } from './NvTabsContent/NvTabsContent.esm.js';
import { NvTabsHeader } from './NvTabsHeader/NvTabsHeader.esm.js';
import './NvTabsHeader/NvTabsHeader.hooks.esm.js';
import { NvTabsTextContent } from './NvTabsTextContent/NvTabsTextContent.esm.js';

var NvTabs = function (_a) {
    var children = _a.children, alignment = _a.alignment, body = _a.body, heading = _a.heading, subheading = _a.subheading, classes = _a.classes, props = __rest(_a, ["children", "alignment", "body", "heading", "subheading", "classes"]);
    var tabs = Children.toArray(children).map(function (_a) {
        var _b = _a.props, titleText = _b.titleText, titleComponent = _b.titleComponent, tabId = _b.tabId, disabled = _b.disabled;
        return {
            disabled: disabled,
            id: tabId,
            tabComponent: titleComponent,
            text: titleText,
        };
    });
    var tabsMap = tabs.reduce(function (acc, _a) {
        var _b;
        var id = _a.id, text = _a.text;
        return (__assign(__assign({}, acc), (_b = {}, _b[id] = text, _b)));
    }, {});
    return (React__default.createElement(NvTabsContainer, __assign({ tabsMap: tabsMap }, props),
        React__default.createElement(NvTabsContent, { alignment: alignment, body: body, classes: classes, heading: heading, subheading: subheading, tabs: tabs }, children)));
};
var NvTabs$1 = Object.assign(NvTabs, {
    Container: NvTabsContainer,
    Header: NvTabsHeader,
    TextContent: NvTabsTextContent,
});

export { NvTabs$1 as default };
//# sourceMappingURL=NvTabs.esm.js.map
